import { render, staticRenderFns } from "./data-shared-popup.html?vue&type=template&id=5e558b24&scoped=true&external"
import script from "./data-shared-popup.js?vue&type=script&lang=js&external"
export * from "./data-shared-popup.js?vue&type=script&lang=js&external"
import style0 from "./data-shared-popup.scss?vue&type=style&index=0&id=5e558b24&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e558b24",
  null
  
)

export default component.exports